import {Form} from "react-bootstrap"
import {useTranslation} from "react-i18next"
import {ExamPeriod, ExamPeriodTerm} from "../types"

type Props = {value: Partial<ExamPeriod>, onChange: (value: Partial<ExamPeriod>) => void}

export default function ExamPeriodForm({value, onChange}: Props) {
    const {t} = useTranslation(["eexam"])

    return (
        <>
            <Form.Group className="mb-3">
                <Form.Label>{t("fields.year")}</Form.Label>
                <Form.Control type="number" value={value.year ?? ""} onChange={event => onChange({...value, year: Number(event.target.value)})}/>
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>{t("fields.term")}</Form.Label>
                <Form.Select value={value.term ?? "summer"} onChange={event => onChange({...value, term: event.target.value as ExamPeriodTerm})}>
                    <option value="summer">{t("terms.summer")}</option>
                    <option value="winter">{t("terms.winter")}</option>
                </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>{t("fields.label")}</Form.Label>
                <Form.Control value={value.label ?? ""} onChange={event => onChange({...value, label: event.target.value})}/>
            </Form.Group>
        </>
    )
}
